<a href="javascript:" (click)="this.searchOn = true" class="pop-search"><i class="feather icon-search"></i></a>
<div class="search-bar" *ngIf="searchOn">
  <input type="text" class="form-control border-0 shadow-none" placeholder="ค้นหา.....">
  <button (click)="this.searchOn = false" type="button" class="close" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>